import React from 'react';
import { theme } from 'antd';
import { ICardComponentProps } from 'store/ducks/Global/types';
import * as Styled from './Card.styled';

const { useToken } = theme;

const CardComponent: React.FC<ICardComponentProps> = ({
  area,
  infoText,
  href,
  minHeight,
  className
}) => {
  const { token } = useToken();
  return (
    <Styled.StyledLinkButton to={href} className={className}>
      <Styled.StyledCard token={token} minHeight={minHeight}>
        <span>{area}</span>
        <Styled.StyledMeta token={token} description={infoText} />
      </Styled.StyledCard>
    </Styled.StyledLinkButton>
  );
};

export default CardComponent;
